import Vue from "vue";
let Dict = {
    store: {
        STATUS: [[1, '启用'], [0, '停用']],
        CORP_TYPE:[[1,'有限责任公司'],[2,'个人独资'],[3,'合伙企业'],[4,'集体所有制企业'],[5,'个体工商户'],[0,'其它']],//企业类型
        ACCESS_STATUS:[[0,'未离场'],[1,'预离场'],[2,'已离场']],
        ACCOUNT_TYPE:[[1,'微信'],[2,'支付宝'],[3,'好收']],
        PARK_CHANNELTYPE:[[1,'入口'],[2,'出口']],
        PAY_WAY:[[1,'微信'],[2,'支付宝'], [5, '小程序']],
        PARKING_ORDER_STATUS:[[1,'未支付'],[2,'支付成功'],[3,'支付失败']],
        PAY_ORDER_STATUS:[[1,'未支付'],[2,'支付成功'],[3,'支付失败'],[4,'已取消']],
        MERCHANT_TYPE:[[1,'普通商户'],[2,'特约商户']],
        PROMOTION_EFFECT_TIMEUNIT:[['day','天'],['hour','小时']],
        PROMOTION_VISIBILITY:[['public','公开'],['private','私有']],
        PROMOTION_STATUS:[[0,'草稿'],[1,'已上架'],[2,'已下架']],
        COUPON_STATUS:[[0,'未使用'],[1,'使用中'],[2,'已使用']],
        
    },
    getEntry: function (key, storeArr) {
        let arr = storeArr || []
        return arr.find((entry) => entry[0] == key)
    },
    getText: function (key, storeArr) {
        let tmp = this.getEntry(key, storeArr)
        return tmp ? tmp[1] : '-'
    }
}
Vue.prototype.$dict = Dict
export default Dict


// WEBPACK FOOTER //
// ./src/utils/Dict.js